<template>
  <BaseNoticeItem :button-text="$t('Edit profile now')" :button-url="buttonUrl">
    <template #head>
      <strong>{{ $t('Your profile is missing some tax information') }}</strong>
    </template>
    <template #body>
      <p>
        {{
          $t(
            "When you accept a job with a U.S. connection (either if you are based in the U.S. or performing work for a client in the U.S.) using Worksome's platform, you must have valid U.S. tax information (W-9 form) on your profile.",
          )
        }}
        {{
          $t(
            'If you are based outside of the U.S. you will just be asked to confirm this, along with your business entity details(W - 8BEN form).',
          )
        }}
      </p>
      <p>
        {{
          $t(
            'So please take notice that until your profile has valid U.S. tax information, you will not be able to accept this contract.',
          )
        }}
      </p>
      <p>
        <a href="https://help.worksome.dk/en/articles/4800383-us-tax-information" target="_blank">
          {{ $t('Read more in our FAQ') }}
        </a>
      </p>
    </template>
  </BaseNoticeItem>
</template>

<script setup>
import { computed, defineProps } from 'vue'
import BaseNoticeItem from '@/components/BaseNoticeItem.vue'
import { useRedirectUri } from '@/composables/redirectUri'
import { useTranslation } from '@/composables/translation'
import { laravelNamedRoute } from '@/utils/laravelNamedRoutes'
import namedRoutes from '@/utils/laravelNamedRoutes.json'

const props = defineProps({
  complianceData: {
    type: Object,
    required: true,
  },
})

const { $t } = useTranslation()

const { redirectUri } = useRedirectUri()

const buttonUrl = computed(() => {
  const path = laravelNamedRoute(namedRoutes.frontend.user.profile.edit, {
    redirect_uri: redirectUri,
  })
  return `${path}#us-tax-information`
})
</script>
